import React from "react";
import styled from "@emotion/styled";
import { motion } from "motion/react";
import { MDSSessionList } from "@/mds/components/sessions/session-list";
import { useMDSSession } from "@/mds/components/sessions/session-context";
import { SESSION_CONTAINER_HEIGHT } from "@/mds/components/sessions/session.constants";

type Props = {};

export const MDSSessionStandardView: React.FC<Props> = () => {
  const { sessionItems, sessionStatus, activeArtifact, sessionConfig } = useMDSSession();

  return (
    <ExpandedContent>
      <motion.div
        key="content"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.2, delay: 0.2, ease: [0.4, 0, 0.2, 1] }}
      >
        <Content>
          <SessionContainer>
            <MDSSessionList
              sessionItems={sessionItems}
              sessionStatus={sessionStatus}
              activeArtifact={activeArtifact}
              containerHeight={SESSION_CONTAINER_HEIGHT}
              sessionConfig={sessionConfig}
            />
          </SessionContainer>
        </Content>
      </motion.div>
    </ExpandedContent>
  );
};

const Content = styled.div``;

const ExpandedContent = styled.div`
  width: 100%;
`;

export const SessionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  max-width: 600px;
`;
